export var colorsPreset = [
    {
        name: 'color0',
        top: '#F5515F',
        bottom: '#9F041B',
    },
    {
        name: 'color1',
        top: '#FFBB00',
        bottom: '#FF0000',
    },
    {
        name: 'color2',
        top: '#FB8013',
        bottom: '#F12452',
    },
    {
        name: 'color3',
        top: '#F2A603',
        bottom: '#C15602',
    },
    {
        name: 'color4',
        top: '#FECF00',
        bottom: '#FEA800',
    },
    {
        name: 'color5',
        top: '#B4EC51',
        bottom: '#429321',
    },
    {
        name: 'color6',
        top: '#06CC84',
        bottom: '#00B500',
    },
    {
        name: 'color7',
        top: '#01C0D8',
        bottom: '#0088EA',
    },
    {
        name: 'color8',
        top: '#53A0FD',
        bottom: '#3023AE',
    },
    {
        name: 'color9',
        top: '#FB1EB7',
        bottom: '#CC1192',
    },
    {
        name: 'color10',
        top: '#8459FF',
        bottom: '#4333EB',
    },
    {
        name: 'color11',
        top: '#C46BD6',
        bottom: '#3123AE',
    },
    {
        name: 'color12',
        top: '#7A8AA1',
        bottom: '#3C4F73',
    },
    {
        name: 'color13',
        top: '#23466C',
        bottom: '#01306A',
    },
    {
        name: 'color14',
        top: '#A8A8A8',
        bottom: '#000000',
    },
];
//# sourceMappingURL=colorsPreset.js.map